/*
 * Desktop PDP: give the Account/Cart pill its fill once the product info
 * column actually starts scrolling under the header.
 *
 * The column (#ProductInfo-<section>, .product__info-container) sits inside a
 * sticky wrapper pinned at top: 81px, one pixel below the condensed header. It
 * holds there for most of the page — measured at 1440x900, its viewport top
 * stays at 81 from scrollY 40 through 2000, then releases and travels up
 * (-388 at 2600, -988 at 3200).
 *
 * While it is pinned nothing passes under the right side of the bar, so a
 * frosted fill there is glass with nothing to frost. The moment it releases,
 * it starts sliding under the header and the fill is wanted.
 *
 * The test is that element's top against the header's own bottom edge. No
 * threshold and no tuned pixel count: both numbers are measured live, so it
 * follows the sticky offset and the header's height if either changes.
 */
(function () {
  var header = document.querySelector('.shopify-section-header');
  if (!header) return;

  var info =
    document.querySelector('.product__info-container') ||
    document.querySelector('[id^="ProductInfo-"]');
  if (!info) return;

  var COVERED = 'header-right-covered';
  var frame = null;

  function measure() {
    frame = null;
    // While pinned the column sits just below the header, so its top is never
    // less than the header's bottom and this stays false. It flips only once
    // the column releases and begins passing underneath.
    var covered =
      info.getBoundingClientRect().top < header.getBoundingClientRect().bottom;
    header.classList.toggle(COVERED, covered);
  }

  function schedule() {
    if (frame === null) frame = requestAnimationFrame(measure);
  }

  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule);
  measure();
})();
